<router-outlet (activate)="changeOfRoutes($event)"></router-outlet>
<div [class.show]="showLoader" class="body-overay">
  <div class="body-loder">
    <img alt="loading...." src="/assets/images/loader.gif" />
    <h3>Loading...</h3>
  </div>
</div>
